
import _ from 'lodash'
import React, { useCallback, useEffect, useState } from 'react'

import http from '../../../lib/http'
import { Select } from '../NarusMaterial'

import { makeAutobindedInput } from './FormBuilder'
import { PractitionerSelectField as AllPractitionersSelectField } from './PractitionerSelect'

const participantToListItems = participant => {
  if (!participant) {
    return [{
      value: ' ',
      display: 'none'
    }]
  }
  return participant.map(mem => {
    const names = [
      _.get(mem, 'name[0].given[0]'),
      _.get(mem, 'name[0].family[0]'),
      _.get(mem, 'name[0].suffix[0]')
    ].filter(x => !!x)
    const name = names.join(' ')
    return {
      value: {
        reference: `${mem.resourceType}/${mem.id}`,
        display: name
      },
      display: name
    }
  })
}

function PatientPractitionersSelect ({ externalReceivers, patientId, value, onChange, floatingLabelText }) {
  const [ items, setItems ] = useState(null)
  const [ inputValue, setInputValue ] = useState(value || '')

  const getParticipants = useCallback((cb) => {
    http.getRequest(`/patients/${patientId}/careNetwork`).then(cb)
  }, [ patientId ])

  const mountParticipants = useCallback(() => {
    getParticipants(res => {
      const receivers = externalReceivers
      let items = participantToListItems(res)

      if (receivers && Array.isArray(receivers) && receivers.length > 0) {
        items = items.concat(
          receivers.map(r => ({
            value: {
              reference: `ExternalReceiver/${r.id}`,
              display: r.name
            },
            display: r.name
          }))
        )
      }

      setItems(items)
    })
  }, [ externalReceivers, getParticipants ])

  function handleChange (event) {
    if (event?.target?.value) {
      const val = JSON.parse(event.target.value)
      setInputValue(val)
      onChange(val)
    } else if (_.isUndefined(event)) {
      setInputValue(undefined)
      onChange(undefined)
    }
  }

  useEffect(() => {
    mountParticipants()
  }, [ mountParticipants ])

  return (
    <div>
      <Select
        data={items?.map(i => ({
          value: JSON.stringify(i.value),
          label: i.display
        }))}
        value={JSON.stringify(inputValue)}
        onChange={handleChange}
        label={floatingLabelText || 'Prescriber'}
      />
    </div>
  )
}

// it would be better to merge this component
// with ./PractitionerSelect. Or make even better decomposition

function CareTeamMemberSelectField ({
  label,
  patientId,
  externalReceivers,
  ...rest
}) {
  return patientId
    ? (
      <PatientPractitionersSelect
        {...rest}
        patientId={patientId}
        floatingLabelText={label || 'Prescriber'}
        externalReceivers={externalReceivers}
      />
    )
    : (
      <AllPractitionersSelectField
        label={label || 'Prescriber'}
        {...rest}
      />
    )
}

export const CareTeamMemberSelectInput = makeAutobindedInput(
  CareTeamMemberSelectField
)
